module.exports = __webpack_public_path__ + "3b4d4d940f24064a8f86afc784b1ef4e.svg";